import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { DragDropDroppableArea } from '../../../DragDrop'
import Text from '../../../Text'
import {
  getCalendarGridDropAreaId,
  getIsCalendarGridDayFull,
  getIsCalendarGridToday,
} from '../../CalendarGrid.utils'
import { CalendarGridDayChips } from '../../CalendarGridDayChips'

import { QA_NAME_CALENDAR_GRID_MONTH_DAY } from './CalendarGridMonthDay.constants'

import * as styles from './CalendarGridMonthDay.module.css'

function CalendarGridMonthDay({
  canMoveItems,
  className = styles.CalendarGridMonthDay,
  day,
  dayLoad,
  items,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { monthLabel } = dayLoad ?? EMPTY_OBJECT

  return (
    <DragDropDroppableArea
      {...getQaSelector({
        context: day.date,
        value: QA_NAME_CALENDAR_GRID_MONTH_DAY,
      })}
      className={classNames(className, {
        [styles.adjacent]: !day.isCurrentMonth,
      })}
      data={{ day: day.date }}
      disabled={!canMoveItems}
      id={getCalendarGridDropAreaId(day.date)}
    >
      <Text
        className={classNames(styles.dayNumber, {
          [styles.dayNumberAdjacent]: !day.isCurrentMonth,
          [styles.dayNumberFull]: getIsCalendarGridDayFull(dayLoad),
          [styles.dayNumberToday]: getIsCalendarGridToday({ day, today }),
        })}
      >
        {day.dayLabel}
      </Text>
      <CalendarGridDayChips
        canMoveItems={canMoveItems}
        day={day.date}
        dayLoad={dayLoad}
        dayLoadLabel={monthLabel}
        items={items}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
    </DragDropDroppableArea>
  )
}

export default CalendarGridMonthDay
